module.exports = __webpack_public_path__ + "kudos_65.svg?f439ddafeac0bfbe8d6dad54697ce192";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_65.svg
// module id = 167
// module chunks = 0